import Router from 'vue-router';

import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout';
import AuthLayout from '@/pages/Dashboard/Pages/AuthLayout';

// Map Pages
import MapOverview from '@/pages/Map/MapOverview';

// Stops Pages
import StopsOverview from '@/pages/Stops/StopsOverview';
import StopDetails from '@/pages/Stops/StopDetails';
import JobsFilter from '@/pages/Jobs/JobsFilter';

// Trips Pages
import TripsOverview from '@/pages/Trips/TripsOverview';
import TripDetails from '@/pages/Trips/TripDetails';

// Shipment Pages
import ShipmentDetails from '@/pages/Shipments/ShipmentDetail';
import ShipmentOverview from '@/pages/Shipments/ShipmentOverview';

// stops schedulers
import StopsScheduler from '@/pages/Scheduler/StopsScheduler';

// Reports
import GpsLocations from '@/pages/Reports/gps/GpsLocations';
import GpsStops from '@/pages/Reports/gps/GpsStops';
import LocationHistoryReport from '@/pages/Reports/LocationHistoryReport';
import DistanceReport from '@/pages/Reports/DistanceReport';
import StopReport from '@/pages/Reports/StopReport';
import IgnitionReport from '@/pages/Reports/IgnitionReport';
import SafetyReport from '@/pages/Reports/SafetyReport';
import SafetySummaryReport from '@/pages/Reports/SafetySummaryReport';
import SpeedingReport from '@/pages/Reports/SpeedingReport';
import GeofenceReport from '@/pages/Reports/GeofenceReport';
import GeofenceTimesheetReport from '@/pages/Reports/GeofenceTimesheetReport';
import DriverPaymentSummary from '@/pages/Reports/DriverPaymentSummary';
import StopRatingReport from '@/pages/Reports/StopRatingReport';
import SmsHistory from '@/pages/Reports/SmsHistory';
import TeamMemberDocumentsReport from '@/pages/Reports/TeamMemberDocumentsReport';

// Billing
import PaymentSuccess from '@/pages/Billing/PaymentSuccess';
import Pricing from '@/pages/Billing/Pricingv2';
import BillingProfile from '@/pages/Billing/BillingProfile';
import BillingAccounts from '@/pages/Billing/BillingAccounts';
import BillingAccountDetails from '@/pages/Billing/BillingAccountDetails';
import EAList from '@/pages/Billing/EAList';

// Home
import HomeDashboard from '@/pages/Home/Dashboard';
// Pages
// import User from "@/pages/Dashboard/Pages/UserProfile.vue";

// import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
import Login from '@/pages/Dashboard/Pages/Login';
import Callback from '@/pages/Dashboard/Pages/Callback';
import Register from '@/pages/Dashboard/Pages/Register';
import SsoLogin from '@/pages/Dashboard/Pages/SsoLogin';
// import Lock from "@/pages/Dashboard/Pages/Lock.vue";

// Team members
import TeamMemberList from '@/pages/TeamMembers/TeamMemberList';
import TeamMemberDetails from '@/pages/TeamMembers/TeamMemberDetails';
import TeamProfile from '@/pages/TeamMembers/TeamProfile';

// Team Settings
import TeamSettings from '@/pages/TeamSettings/TeamSettings';
import RunSheetSettings from '@/pages/TeamSettings/RunSheet/RunSheetSettings';

// Team Regions
import TeamRegionsOverview from '@/pages/TeamRegions/TeamRegionsOverview';

// Team Carriers
import TeamCarriersOverview from '@/pages/TeamCarriers/TeamCarriersOverview';

import TeamInviteLayout from '@/pages/Dashboard/Pages/TeamInvite';

import UserProfile from '@/pages/User/UserProfile';
import UserSettings from '@/pages/User/UserSettings';

import AssetDashboard from '@/pages/AssetTracking/AssetDashboard';

// Mobile layouts
import MobileStopOverview from '@/pages-mobile/Stops/StopOverviewMobile';
import MobileWelcomeDashboard from '@/pages-mobile/Dashboard/WelcomeDashboardMobile';
import MobileTripOverview from '@/pages-mobile/Trips/TripOverviewMobile';
import MobileShipmentOverview from '@/pages-mobile/Shipments/ShipmentsOverviewMobile';
import MobileCustomerOverview from '@/pages-mobile/Customers/CustomerOverviewMobile';

// Run Schedules Pages
import RunsOverview from '@/pages/RunSchedules/RunsOverview';
import RunScheduleDetails from '@/pages/RunSchedules/RunScheduleDetails';

import Demo from '@/pages/Reports/Demo';

import Widgets from '@/pages/Dashboard/Widgets';

import CustomerOverview from '@/pages/Customer/CustomerOverview';
import CustomerDetails from '@/pages/Customer/CustomerDetails';

import WarehousesOverview from '@/pages/Warehouses/WarehousesOverview';

// Inventory Pages
import InventoryOverview from '@/pages/Inventory/InventoryOverview';
import InventoryDetails from '@/pages/Inventory/InventoryDetails';

// Team member Invoices pages
import TeamMemberInvoices from '@/pages/TeamMemberInvoices/TeamMemberInvoices';
import TeamMemberInvoicesDetails from '@/pages/TeamMemberInvoices/TeamMemberInvoicesDetails';
import TeamMemberInvoice from '@/pages/InvoicesAgGrid/TeamMemberInvoices/TeamMemberInvoice';

// Customer Invoices pages
import CustomerInvoicesOverview from '@/pages/CustomerInvoices/CustomerInvoicesOverview';
import CustomerInvoicesDetails from '@/pages/CustomerInvoices/CustomerInvoicesDetails';

// Services
import ServicesOverview from '@/pages/Services/ServicesOverview';

import { isMobile, isMobileOnly } from 'mobile-device-detect';

// Asset Managements
import AssetDetails from '@/pages/AssetTracking/AssetDetails';
import AssetGroupDetails from '@/pages/AssetTracking/AssetGroupDetails';

import Marketplace from '@/pages/CarrierMarketplace/Marketplace';

import MaintenanceScheduleOverview from '@/pages/Maintenance/MaintenanceScheduleOverview';
import UpcomingMaintenanceSchedule from '@/pages/Maintenance/UpcomingMaintenanceSchedule';

// Rates
import RatesDashboard from '@/pages/Rates/RatesDashboard';
import RateZonesOverview from '@/pages/TeamSettings/RateZones/RateZonesOverview';

// Dispatch Dashboard
import DispatchDashboard from '@/pages/DispatchDashboard/DispatchDashboard';

// Business Entities
import BusinessEntitiesOverview from '@/pages/TeamSettings/BusinessEntities/BusinessEntitiesOverview';
import BusinessEntityDetails from '@/pages/TeamSettings/BusinessEntities/BusinessEntityDetails';

// Frequent Entities
import FrequentAddressesOverview from '@/pages/FrequentAddresses/FrequentAddressesOverview';
import FrequentAddressDetails from '@/pages/FrequentAddresses/FrequentAddressDetails';

// Components pages
// import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
// import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
// import Panels from "@/pages/Dashboard/Components/Panels.vue";
// import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
// import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
// import Icons from "@/pages/Dashboard/Components/Icons.vue";
// import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
// import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
// import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
// import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
// import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
// import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
// import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
// import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Charts
// import Charts from '@/pages/Dashboard/Charts';
// import Widgets from '@/pages/Dashboard/Widgets';

// Dashboard
// import Dashboard from '@/pages/Dashboard/Dashboard';

// Optimise Stops
import BatchStops from '@/pages/BatchStop/OptimiseStops';
import OptimiseStops from '@/pages/OptimiseStops/OptimiseStops';

// Onboarding
import GettingStarted from '@/pages/Onboarding/GettingStarted';

// settings Menu
import GeneralSettings from '@/pages/TeamSettings/GeneralSettings';
import CustomFields from '@/pages/TeamSettings/BookingFields/CustomFields';
import StopCustomFieldsList from '@/pages/TeamSettings/BookingFields/components/StopCustomFieldsList';
import ShipmentCustomFieldsList from '@/pages/TeamSettings/BookingFields/components/ShipmentCustomFieldsList';
import AssetCustomFieldsList from '@/pages/TeamSettings/BookingFields/components/AssetCustomFieldsList';
import SkillList from '@/pages/TeamSettings/SkillList';
import SmsSettings from '@/pages/TeamSettings/SmsSettings';
import Apps from '@/pages/TeamSettings/Apps';
import GeofenceEventsSettings from '@/pages/TeamSettings/GeofenceEventsSettings';
import CapacitySettings from '@/pages/TeamSettings/CapacitySettings';
import QuestionsList from '@/pages/TeamSettings/QuestionsList';
import ImportMappings from '@/pages/TeamSettings/ImportMappings';
import Accounts from '@/pages/TeamSettings/Accounts';
import CustomActionSettings from '@/pages/TeamSettings/CustomActions/CustomActionSettings';
import BrandSettings from '@/pages/TeamSettings/Brands/Brands';
import ItemSettings from '@/pages/TeamSettings/Items/Items';

import AppPermissionSettings from '@/pages/TeamSettings/AppPermissionSettings';

import JobOfferSettingsPage from '@/pages/TeamSettings/JobOffers/JobOfferSettingsPage';
import ServiceAreasOverview from '@/pages/TeamSettings/ServiceAreas/ServiceAreasOverview';
import ServiceAreasDeliveryWindowPage from '@/pages/TeamSettings/ServiceAreas/DeliveryWindows/ServiceAreasDeliveryWindowPage';
import ServiceAreasBlockoutDayPage from '@/pages/TeamSettings/ServiceAreas/BlockoutDays/ServiceAreasBlockoutDayPage';
import ServiceAreasOverrideDayPage from '@/pages/TeamSettings/ServiceAreas/OverrideDayWindows/ServiceAreasOverrideDayPage';
import ServiceAreasDashboardOverview from '@/pages/TeamSettings/ServiceAreas/Dashboard/ServiceAreasDashboardOverview';

import DriverInstructions from '@/pages/TeamSettings/DriverInstructions';
import ShipmentContents from '@/pages/TeamSettings/ShipmentContents';
import BreakManagementOverview from '@/pages/TeamSettings/BreakManagement/BreakManagementOverview';

import ReviewChargesOverview from '@/pages/ProcessCharges/ReviewChargesOverview';
import ProcessChargesTripsGrid from '@/pages/ProcessChargesTrips/ProcessChargesTripsGrid';
import ProcessChargesStopsGrid from '@/pages/ProcessChargesStops/ProcessChargesStopsGrid';
import ProcessChargesShipmentsGrid from '@/pages/ProcessChargesShipments/ProcessChargesShipmentsGrid';
import CreateTripPage from '@/pages/Trips/CreateTripPage';
import TripMapRoutes from '@/pages/Trips/TripMapRoutes';

import { handleRequests, canRouteAndShow } from '@/helpers';
import { store } from '@/store/store';

import ProofOfDeliveryTemplateParent from '@/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplateParent';
import ProofOfDeliveryTemplatePage from '@/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplatePage';
import ProofOfDeliveryTemplateListPage from '@/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplateListPage';

import FailedDeliveryConfiguration from '@/pages/TeamSettings/FailedDeliveryConfiguration';

import OrdersOverview from '@/pages/Orders/OrdersOverview';
import OrderDetails from '@/pages/Orders/OrderDetails';
import CreateOrderPage from '@/pages/Orders/CreateOrderPage';
import EditOrderPage from '@/pages/Orders/EditOrderPage';

import Tags from '@/pages/TeamSettings/Tags';
import VisionList from '@/pages/Vision/VisionList';

import IssueList from '@/pages/Issues/IssueList';

// eslint-disable-next-line no-unused-vars
import { FEATURE_NAMES, NEW_BILLING_VERSION } from '@/utils/constants';

import TripRunsDetails from '@/pages/Runs/TripRunsDetails';

import MapOverviewMapBox from '../pages/Map/MapOverviewMapBox';

const mapsMenu = {
    path: '/mapview',
    component: DashboardLayout,
    name: 'Map',
    meta: {
        isSecure: true,
        hideFooter: true,
        hideTopbar: true,
        isMap: true,
        title: 'Map',
        security: {
            id: 'map'
        }
    },
    redirect: '/map',
    children: [
        {
            path: '/map',
            component: MapOverview,
            name: 'Maps Overview',
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                isMap: true,
                title: 'Map'
            },
            children: [
                {
                    path: ':date',
                    name: 'Maps Overview Selected Date',
                    components: {
                        default: MapOverview
                    },
                    meta: {
                        isSecure: true,
                        hideFooter: true,
                        hideTopbar: true,
                        isMap: true,
                        title: 'Map'
                    },
                    children: [
                        {
                            path: ':group',
                            name: 'Maps Overview Active Panel',
                            components: {
                                default: MapOverview
                            },
                            meta: {
                                isSecure: true,
                                hideFooter: true,
                                hideTopbar: true,
                                isMap: true,
                                title: 'Map'
                            }
                        },
                        {
                            path: 'user/:userId',
                            name: 'Maps Overview Active User Panel',
                            components: {
                                default: MapOverview
                            },
                            meta: {
                                isSecure: true,
                                hideFooter: true,
                                hideTopbar: true,
                                isMap: true,
                                title: 'Map'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const newMapMenu = {
    path: '/mapview2',
    component: DashboardLayout,
    name: 'Map (Mapbox)',
    meta: {
        isSecure: true,
        hideFooter: true,
        hideTopbar: true,
        isMap: true,
        title: 'Map',
        security: {
            id: 'map2'
        }
    },
    redirect: '/map2',
    children: [
        {
            path: '/map2',
            component: MapOverviewMapBox,
            name: 'Maps Overview (Mapbox)',
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                isMap: true,
                title: 'Map'
            },
            children: [
                {
                    path: ':date',
                    name: 'Maps Overview Selected Date (Mapbox)',
                    components: {
                        default: MapOverviewMapBox
                    },
                    meta: {
                        isSecure: true,
                        hideFooter: true,
                        hideTopbar: true,
                        isMap: true,
                        title: 'Map'
                    },
                    children: [
                        {
                            path: ':group',
                            name: 'Maps Overview Active Panel (Mapbox)',
                            components: {
                                default: MapOverviewMapBox
                            },
                            meta: {
                                isSecure: true,
                                hideFooter: true,
                                hideTopbar: true,
                                isMap: true,
                                title: 'Map'
                            }
                        },
                        {
                            path: 'user/:userId',
                            name: 'Maps Overview Active User Panel (Mapbox)',
                            components: {
                                default: MapOverviewMapBox
                            },
                            meta: {
                                isSecure: true,
                                hideFooter: true,
                                hideTopbar: true,
                                isMap: true,
                                title: 'Map'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const jobsMenu = {
    path: '/jobs',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Jobs',
        security: {
            id: 'jobs',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Support Staff'],
            featureRestrictions: [FEATURE_NAMES.JobsSearch],
            featureRestrictionType: 'hide'
        }
    },
    redirect: '/jobs/filter',
    name: 'Jobs',
    children: [
        {
            path: 'filter',
            name: 'Jobs Filter',
            components: {
                default: JobsFilter
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Jobs Filter'
            }
        }
    ]
};

const stopsMenu = {
    path: '/stops',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Stops',
        security: {
            id: 'stops'
        }
    },
    redirect: '/stops/list',
    name: 'Stops',
    children: [
        {
            path: 'list',
            name: 'Stops Overview',
            components: {
                default: !isMobileOnly ? StopsOverview : MobileStopOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Stops'
            },
            children: [
                {
                    path: ':userId',
                    name: 'Stops List Filter',
                    components: {
                        default: !isMobileOnly ? StopsOverview : MobileStopOverview
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Stops'
                    }
                }
            ]
        },
        {
            path: 'calendar',
            name: 'Calendar',
            components: {
                default: StopsScheduler
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Stops Calendar',
                security: {
                    id: 'calendar',
                    roles: ['Team Owner', 'Team Manager', 'Office Staff'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            },
            children: [
                {
                    path: ':type',
                    name: 'Stops Calendar',
                    components: {
                        default: StopsScheduler
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true
                    }
                }
            ]
        },
        {
            path: 'details/:stopId',
            name: 'Stop Details',
            components: {
                default: StopDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const tripsMenu = {
    path: '/trips',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Trips',
        security: {
            id: 'trips'
        }
    },
    redirect: '/trips/list',
    name: 'Trips',
    children: [
        {
            path: 'create',
            name: 'Create Trip',
            components: {
                default: CreateTripPage
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Create Trip'
            }
        },
        {
            path: 'list',
            name: 'Trips Overview',
            components: {
                default: !isMobileOnly ? TripsOverview : MobileTripOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Trips'
            },
            children: [
                {
                    path: ':date',
                    name: 'Trip List Selected Date',
                    components: {
                        default: TripsOverview
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Trips'
                    }
                }
            ]
        },
        {
            path: 'details/:tripId',
            name: 'Trip Details',
            components: {
                default: TripDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Trip Details'
            }
        },
        {
            path: 'routes/:date/:userId?',
            name: 'Trip Routes',
            components: {
                default: TripMapRoutes
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Trip Routes',
                isOptimise: true,
                security: {
                    roles: [
                        'Team Owner',
                        'Team Manager',
                        'Office Staff',
                        'Support Staff',
                        'Customer',
                        'Customer Admin',
                        'Sales'
                    ]
                }
            }
        }
    ]
};

const CustomerMenu = {
    path: '/customers',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Customer List',
        security: {
            id: 'customers',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Sales'],
            isVisible: ['hasTeam']
        }
    },
    redirect: '/customers/list',
    name: 'Customers',
    children: [
        {
            path: 'list',
            name: 'Customers List',
            components: {
                default: !isMobileOnly ? CustomerOverview : MobileCustomerOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Customer List'
            }
        },
        {
            // for redirect purposes
            path: 'details',
            redirect: '/customers/list'
        },
        {
            path: 'details/:customerId',
            name: 'Customer Details',
            components: {
                default: CustomerDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Customer Details'
            }
        }
    ]
};

const warehousesMenu = {
    path: '/warehouses',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Warehouses List',
        security: {
            id: 'warehouses',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/warehouses/list',
    name: 'Warehouses',
    children: [
        {
            path: 'list',
            name: 'Warehouses List',
            components: {
                default: WarehousesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Warehouses List'
            }
        }
    ]
};

const ordersMenu = {
    path: '/orders',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Orders List',
        security: {
            id: 'orders',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager'],
            isVisible: ['hasTeam', 'desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.Orders]
        }
    },
    redirect: '/orders/list',
    name: 'Orders',
    children: [
        {
            path: 'create',
            name: 'Create Order',
            components: {
                default: CreateOrderPage
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Create Order'
            }
        },
        {
            path: 'edit/:orderId',
            name: 'Edit Order',
            components: {
                default: EditOrderPage
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Edit Order'
            }
        },
        {
            path: 'list',
            name: 'Orders List',
            components: {
                default: OrdersOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Orders List'
            }
        },
        {
            // for redirect purposes
            path: 'details',
            redirect: '/orders/list'
        },
        {
            path: 'details/:orderId',
            name: 'Order Details',
            components: {
                default: OrderDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Order Details'
            }
        }
    ]
};

const warehouseWebAppRoute = {
    path: '/warehouse-web-app-placeholder',
    meta: {
        isSecure: true,
        title: 'Warehouse Web App',
        security: {
            id: 'warehouse-web-app',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager'],
            isVisible: ['hasTeam', 'desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.WarehouseWebApp]
        }
    },
    redirect: '/warehouse-inventory',
    name: 'WarehouseWebApp'
};

const inventoryMenu = {
    path: '/inventory',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Inventory List',
        security: {
            id: 'inventory',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/inventory/list',
    name: 'Inventory',
    children: [
        {
            path: 'list',
            name: 'Inventory List',
            components: {
                default: InventoryOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Inventory List'
            }
        },
        {
            path: 'details/:itemId',
            name: 'Inventory Details',
            components: {
                default: InventoryDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const teamMemberInvoicesMenu = {
    path: '/team-member-invoices',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Team Member Invoices List',
        security: {
            id: 'team-member-invoices',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Team Member'],
            isVisible: ['hasTeam']
        }
    },
    redirect: '/team-member-invoices/list',
    name: 'TeamMemberInvoices',
    children: [
        {
            path: 'list',
            name: 'Team Member Invoices List',
            components: {
                default: TeamMemberInvoices
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Team Member Invoices List'
            },
            children: [
                {
                    path: ':type',
                    name: 'Invoice Type',
                    components: {
                        default: TeamMemberInvoices
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true
                    }
                }
            ]
        },
        {
            path: 'details/:invoiceId',
            name: 'Team Member Invoice Details',
            components: {
                default: TeamMemberInvoicesDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'details/:invoiceId/approve',
            name: 'Team Member Invoice Details',
            components: {
                default: TeamMemberInvoicesDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'details/:invoiceId/review',
            name: 'Team Member Invoice Details',
            components: {
                default: TeamMemberInvoicesDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const customerInvoicesMenu = {
    path: '/customer-invoices',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Customer Invoices List',
        security: {
            id: 'customer-invoices',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Customer Admin', 'Customer'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/customer-invoices/list',
    name: 'CustomerInvoices',
    children: [
        {
            path: 'list',
            name: 'Customer Invoices List',
            components: {
                default: CustomerInvoicesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Customer Invoices List'
            }
        },
        {
            path: 'details/:invoiceId',
            name: 'Customer Invoice Details',
            components: {
                default: CustomerInvoicesDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const shipmentsMenu = {
    path: '/shipments',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Shipments',
        security: {
            id: 'shipments'
        }
    },
    redirect: '/shipments/list',
    name: 'Shipments',
    children: [
        {
            path: 'list',
            name: 'Shipment List',
            components: {
                default: !isMobileOnly ? ShipmentOverview : MobileShipmentOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'details/:shipmentId',
            name: 'Shipment Details',
            components: {
                default: ShipmentDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: ':shipmentId/dispatch',
            name: 'Dispatch Dashboard',
            components: {
                default: DispatchDashboard
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                isMap: true
            }
        }
    ]
};

const marketPlace = {
    path: '/marketplace',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Marketplace',
        security: {
            id: 'marketplace',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.CarrierMarketplace]
        }
    },
    redirect: '/marketplace/apps',
    name: 'Marketplace',
    children: [
        {
            path: 'apps',
            name: 'Marketplace apps',
            components: {
                default: Marketplace
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const processChargesMenu = {
    path: '/processcharges',
    component: DashboardLayout,
    isVisible: ['hasTeam', 'desktopOnly'],
    meta: {
        isSecure: true,
        title: 'Process Charges',
        security: {
            id: 'process-charges',
            roles: ['Team Owner', 'Team Manager'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/processcharges/list',
    name: 'In',
    children: [
        {
            path: 'list',
            name: 'Charges',
            components: {
                default: ReviewChargesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Charges'
            },
            children: [
                {
                    path: ':type',
                    name: 'Review Type',
                    components: {
                        default: ReviewChargesOverview
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Charges'
                    }
                }
            ]
        }
    ]
};

const processChargesMenuAgGrid = {
    path: '/processcharges',
    component: DashboardLayout,
    isVisible: ['hasTeam', 'desktopOnly'],
    meta: {
        isSecure: true,
        title: 'Process Charges',
        security: {
            id: 'process-charges-grid',
            roles: ['Team Owner', 'Team Manager'],
            isVisible: ['hasTeam', 'desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.ProcessCharges]
        }
    },
    redirect: '/processcharges/trips',
    name: 'In',
    children: [
        {
            path: 'trips', // New Grid based
            name: 'Process Trips Charges (Grid)',
            components: {
                default: ProcessChargesTripsGrid
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Process Charges Trips Grid'
            }
        },
        {
            path: 'stops', // New Grid based for Stops
            name: 'Process Stops Charges (Grid)',
            components: {
                default: ProcessChargesStopsGrid
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Process Charges Stops Grid'
            }
        },
        {
            path: 'shipments', // New Grid based for Shipments
            name: 'Process Shipments Charges (Grid)',
            components: {
                default: ProcessChargesShipmentsGrid
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Process Charges Shipments Grid'
            }
        }
    ]
};

const standaloneUserTeamMenu = {
    path: '/team/standalone-member',
    component: DashboardLayout,
    name: 'Team',
    meta: {
        isSecure: true,
        security: {
            id: 'team-standalone-settings-menu',
            isVisible: ['standalone']
        }
    },
    redirect: '/team/team-members'
};

const teamMembersMenu = {
    path: '/team',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'team-settings-menu',
            roles: ['Team Owner', 'Team Manager'],
            isVisible: ['desktopOnly', 'hasTeam']
        }
    },
    redirect: '/team/team-members',
    name: 'Team Member List',
    children: [
        {
            path: 'team-members/:publicUserId',
            name: 'Team Member Profile',
            components: {
                default: TeamMemberDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'team-members',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['desktopOnly']
                }
            }
        },
        {
            path: 'profile',
            name: 'Team Profile',
            components: {
                default: TeamProfile
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Team Profile',
                security: {
                    id: 'team-profile',
                    roles: ['Team Owner'],
                    isVisible: ['desktopOnly', 'standalone', 'hasTeam']
                }
            }
        },
        {
            path: 'carriers',
            name: 'Carriers',
            components: {
                default: TeamCarriersOverview
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                title: 'Carriers',
                security: {
                    id: 'carriers',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly'],
                    featureRestrictions: [FEATURE_NAMES.CarrierMarketplace]
                }
            }
        },
        {
            path: 'services',
            name: 'Services',
            components: {
                default: ServicesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Services',
                security: {
                    id: 'services',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'settings',
            name: 'Team Settings',
            components: {
                default: TeamSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'team-settings',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'run-schedules',
            name: 'Runs Schedules',
            components: {
                default: RunsOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Runs Schedules',
                security: {
                    id: 'run-schedules',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'team-regions',
            name: 'Team Regions',
            components: {
                default: TeamRegionsOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Team Regions',
                security: {
                    id: 'team-regions',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: ':type',
            name: 'Team Members',
            components: {
                default: TeamMemberList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'run-schedule-details/:runScheduleId',
            name: 'Run Schedule Details',
            components: {
                default: RunScheduleDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Run Schedule Details',
                security: {
                    id: 'run-schedules',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        }
    ]
};

const invitePage = {
    path: '/invite/:invitecode',
    component: TeamInviteLayout,
    name: 'Team Invite'
};

const authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/callback',
            name: 'Callback',
            component: Callback
        },
        {
            // Branded enterprise SSO entry (Epic CORE-6317 F9): /{slug}/login → IS /{slug}/login → Entra.
            // Public route (no meta.isSecure) so the auth guard lets it through to start the redirect.
            path: '/:slug/login',
            name: 'SsoLogin',
            component: SsoLogin
        }
    ]
};

const userProfile = {
    path: '/profile',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager', 'Team Member', 'Sales'],
            isVisible: ['hasTeam', 'desktopOnly', 'standalone']
        }
    },
    redirect: '/profile/view',
    name: 'UserProfile',
    children: [
        {
            path: 'view',
            name: 'User Profile',
            components: {
                default: UserProfile
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'settings',
            name: 'User Settings',
            components: {
                default: UserSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const assetTrackingMenu = {
    path: '/assets',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'assets',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/assets/overview',
    name: 'AssetDashboard',
    children: [
        {
            path: 'overview',
            name: 'Asset Dashboard',
            components: {
                default: AssetDashboard
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            },
            children: [
                {
                    path: ':type',
                    name: 'Asset Dashboard Type',
                    components: {
                        default: AssetDashboard
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Asset Dashboard'
                    }
                }
            ]
        },
        {
            path: 'details/:assetId',
            name: 'Asset Details',
            components: {
                default: AssetDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'group/details/:assetGroupId',
            name: 'Asset Group Details',
            components: {
                default: AssetGroupDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const maintenanceMenu = {
    path: '/maintenance',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'maintenance',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/maintenance/overview',
    name: 'MaintenanceDashboard',
    children: [
        {
            path: 'schedules',
            name: 'Maintenance Schedule Dashboard',
            components: {
                default: MaintenanceScheduleOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'upcoming',
            name: 'Upcoming Maintenance Schedule',
            components: {
                default: UpcomingMaintenanceSchedule
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const gpsReportsMenu = {
    path: '/gps-reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Gps Reports',
        security: {
            id: 'gps-reports'
        }
    },
    redirect: '/gps-reports/locations',
    name: 'GpsReports',
    children: [
        {
            path: 'locations',
            name: 'Gps Locations',
            components: {
                default: GpsLocations
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'gps-locations',
                    roles: ['Team Owner', 'Team Manager', 'Office Staff'],
                    featureRestrictions: [FEATURE_NAMES.RealtimeGpsReports],
                    isVisible: ['desktopOnly'],
                    isSupportOnly: true, // TEMPORARY FLAG TO HIDE FROM NON-SUPPORT ROLES WHILE OUTPUT VERIFICATION IS IN PROGRESS
                    isSupportOnlyWhileJoinedToTeam: true // SHOW IF SUPPORT AND JOINED TO A TEAM
                }
            }
        },
        {
            path: 'stops',
            name: 'Gps Stops',
            components: {
                default: GpsStops
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'gps-stops',
                    roles: ['Team Owner', 'Team Manager', 'Office Staff'],
                    featureRestrictions: [FEATURE_NAMES.RealtimeGpsReports],
                    isVisible: ['desktopOnly'],
                    isSupportOnly: true, // TEMPORARY FLAG TO HIDE FROM NON-SUPPORT ROLES WHILE OUTPUT VERIFICATION IS IN PROGRESS
                    isSupportOnlyWhileJoinedToTeam: true // SHOW IF SUPPORT AND JOINED TO A TEAM
                }
            }
        }
    ]
};

const locationHistoryReport = {
    path: '/reports',
    component: DashboardLayout,
    roles: ['Team Owner', 'Team Manager', 'Office Staff'],
    meta: {
        isSecure: true,
        security: {
            id: 'location-history-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/reports/location-history-report',
    name: 'LocationHistoryReport',
    children: [
        {
            path: 'location-history-report',
            name: 'Location History Report',
            components: {
                default: LocationHistoryReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const stopReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'stop-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/reports/stop-report',
    name: 'StopReport',
    children: [
        {
            path: 'stop-report',
            name: 'Stop Report',
            components: {
                default: StopReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const distanceReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'distance-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['desktopOnly']
        }
    },
    redirect: '/reports/distance-report',
    name: 'DistanceReport',
    children: [
        {
            path: 'distance-report',
            name: 'Distance Report',
            components: {
                default: DistanceReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const ignitionReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'ignition-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['desktopOnly']
        }
    },
    redirect: '/reports/ignition-report',
    name: 'IgnitionReport',
    children: [
        {
            path: 'ignition-report',
            name: 'Ignition Report',
            components: {
                default: IgnitionReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const safetyReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'safety-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['desktopOnly']
        }
    },
    redirect: '/reports/safety-report',
    name: 'SafetyReport',
    children: [
        {
            path: 'safety-report',
            name: 'Safety Report',
            components: {
                default: SafetyReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const safetySummaryReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'safety-summary-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/reports/safety-summary-report',
    name: 'SafetySummaryReport',
    children: [
        {
            path: 'safety-summary-report',
            name: 'Safety Summary Report',
            components: {
                default: SafetySummaryReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const speedingReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'speeding-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/reports/speeding-report',
    name: 'SpeedingReport',
    children: [
        {
            path: 'speeding-report',
            name: 'Speeding Report',
            components: {
                default: SpeedingReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const geofenceReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'geofence-report',
            isVisible: ['desktopOnly'],
            roles: [
                'Team Owner',
                'Team Manager',
                'Office Staff',
                'Support Staff',
                'Sales',
                'Warehouse Manager',
                'Support Admin',
                'Support',
                'Asset'
            ]
        }
    },
    redirect: '/reports/geofence-report',
    name: 'GeofenceReport',
    children: [
        {
            path: 'geofence-report',
            name: 'Geofence Report',
            components: {
                default: GeofenceReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const geofenceTimesheetReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'geofence-timesheet',
            isVisible: ['desktopOnly'],
            roles: [
                'Team Owner',
                'Team Manager',
                'Office Staff',
                'Support Staff',
                'Sales',
                'Warehouse Manager',
                'Support Admin',
                'Support',
                'Asset'
            ]
        }
    },
    redirect: '/reports/geofence-timesheet',
    name: 'GeofenceTimesheet',
    children: [
        {
            path: 'geofence-timesheet',
            name: 'Geofence Timesheet',
            components: {
                default: GeofenceTimesheetReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const driverPaymentSummary = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'driver-payment-summary',
            roles: ['Team Owner'],
            isVisible: ['desktopOnly']
        }
    },
    redirect: '/reports/driver-payment-summary',
    name: 'DriverPaymentSummary',
    children: [
        {
            path: 'driver-payment-summary',
            name: 'Driver Payment Summary',
            components: {
                default: DriverPaymentSummary
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const stopRatingReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'stop-rating-report',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['desktopOnly']
        }
    },
    redirect: '/reports/stop-rating-report',
    name: 'StopRatingReport',
    children: [
        {
            path: 'stop-rating-report',
            name: 'Stop Rating Report',
            components: {
                default: StopRatingReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const smsHistory = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true
    },
    redirect: '/reports/sms-history',
    name: 'SmsHistory',
    children: [
        {
            path: 'sms-history',
            name: 'Sms History',
            components: {
                default: SmsHistory
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'sms-history',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly'],
                    featureRestrictions: [FEATURE_NAMES.SmsHistory]
                }
            }
        }
    ]
};

const teamMemberDocumentReport = {
    path: '/reports',
    component: DashboardLayout,
    meta: {
        isSecure: true
    },
    redirect: '/reports/team-member-documents',
    name: 'TeamMemberDocuments',
    children: [
        {
            path: 'team-member-documents',
            name: 'Team Member Documents',
            components: {
                default: TeamMemberDocumentsReport
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'team-member-documents',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        }
    ]
};

const paymentSuccess = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true
    },
    redirect: '/payment-success',
    name: 'PaymentSuccess',
    children: [
        {
            path: 'payment-success',
            name: 'Payment Success',
            components: {
                default: PaymentSuccess
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const pricing = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            roles: ['Team Owner']
        }
    },
    redirect: '/pricing',
    name: 'PricingPlans',
    beforeEnter(to, from, next) {
        if (to.params.token) {
            window.open(`https://locate2u.recurly.com/account/${to.params.token}`, '_blank');
        } else if (to.query.token) {
            window.open(`https://locate2u.recurly.com/account/${to.query.token}`, '_blank');
        } else {
            next();
        }
    },
    children: [
        {
            path: 'pricing',
            name: 'Pricing',
            components: {
                default: Pricing
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const homeDashboard = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'dashboard',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Warehouse Manager', 'Sales'],
            isVisible: ['showOnMobile', 'hasTeam']
        }
    },
    redirect: '/dashboard',
    name: 'HomeDashboard',
    children: [
        {
            path: 'dashboard',
            name: 'Home Dashboard',
            components: {
                default: !isMobileOnly ? HomeDashboard : MobileWelcomeDashboard
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Dashboard'
            }
        }
    ]
};

const batchStops = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'optimise-stops-mapbox',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', '!useNewOptimiseStops', 'desktopOnly']
        }
    },
    redirect: '/optimise',
    name: 'Optimise',
    children: [
        {
            path: 'optimise',
            name: 'Optimise Stops',
            components: {
                default: BatchStops
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                isOptimise: true
            }
        }
    ]
};

const optimiseStops = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'optimise-stops-google',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            isVisible: ['hasTeam', 'useNewOptimiseStops', 'desktopOnly']
        }
    },
    redirect: '/optimise-stops',
    name: 'New Optimise',
    children: [
        {
            path: 'optimise-stops',
            name: 'New Optimise Stops',
            components: {
                default: OptimiseStops
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                isOptimise: true
            }
        }
    ]
};

const demo = {
    path: '/demo',
    component: Demo,
    name: 'Demo',
    meta: {
        isSecure: true,
        shouldLoginAutomatically: true
    }
};

const onboarding = {
    path: '/support/',
    component: DashboardLayout,
    meta: {
        isSecure: true
    },
    redirect: '/support/onboarding',
    name: 'Onboarding',
    children: [
        {
            path: 'onboarding',
            name: 'Getting Started',
            components: {
                default: GettingStarted
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                isOptimise: true,
                security: {
                    roles: ['Team Owner']
                }
            }
        }
    ]
};

const settingsMenu = {
    path: '/settings',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            roles: ['Team Owner']
        }
    },
    name: 'settings menu',
    children: [
        {
            path: 'general-settings',
            name: 'General Settings',
            components: {
                default: GeneralSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'custom-fields',
            name: 'Custom Fields',
            components: {
                default: CustomFields
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'stop-custom-fields',
            name: 'Stop Custom Fields',
            components: {
                default: StopCustomFieldsList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'shipment-custom-fields',
            name: 'Shipment Custom Fields',
            components: {
                default: ShipmentCustomFieldsList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'asset-custom-fields',
            name: 'Asset Custom Fields',
            components: {
                default: AssetCustomFieldsList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'skills',
            name: 'Skills',
            components: {
                default: SkillList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'sms-settings',
            name: 'SMS Settings',
            components: {
                default: SmsSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'proof-of-delivery-configuration',
            name: 'Proof Of Delivery Configuration',
            component: ProofOfDeliveryTemplateParent,
            redirect: 'proof-of-delivery-configuration/list',
            children: [
                {
                    path: 'list',
                    name: 'Proof Of Delivery Template List',
                    component: ProofOfDeliveryTemplateListPage,
                    meta: {
                        hideFooter: true,
                        hideTopbar: true
                    }
                },
                {
                    path: 'create',
                    name: 'Create Proof Of Delivery Template',
                    component: ProofOfDeliveryTemplatePage,
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        mode: 'create'
                    }
                },
                {
                    path: ':podTemplateId',
                    name: 'Edit Proof Of Delivery Template',
                    component: ProofOfDeliveryTemplatePage,
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        mode: 'edit'
                    }
                }
            ]
        },
        {
            path: 'apps',
            name: 'Apps',
            components: {
                default: Apps
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'geofence-events-settings',
            name: 'Geofence Events Settings',
            components: {
                default: GeofenceEventsSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'capacity-settings',
            name: 'Capacity Settings',
            components: {
                default: CapacitySettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'questions',
            name: 'Questions',
            components: {
                default: QuestionsList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'import-mappings',
            name: 'Import Mappings',
            components: {
                default: ImportMappings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'items',
            name: 'Items',
            components: {
                default: ItemSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'run-sheet',
            name: 'Run Sheet Settings',
            components: { default: RunSheetSettings },
            meta: { hideFooter: true, hideTopbar: true }
        },
        {
            path: 'accounts',
            name: 'Accounts',
            components: {
                default: Accounts
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'custom-actions',
            name: 'Custom Actions',
            components: {
                default: CustomActionSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'job-offers',
            name: 'Job Offer Settings',
            components: {
                default: JobOfferSettingsPage
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            },
            children: [
                {
                    path: ':teamRegionId',
                    name: 'Job Offer Settings Team Region Level',
                    components: {
                        default: JobOfferSettingsPage
                    },
                    meta: {
                        isSecure: true,
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Job Offer Settings'
                    }
                }
            ]
        },
        {
            path: 'brands',
            name: 'Brands',
            components: {
                default: BrandSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'app-permission-settings',
            name: 'App Permission Settings',
            components: {
                default: AppPermissionSettings
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'service-areas',
            name: 'Service Areas',
            components: {
                default: ServiceAreasOverview
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                isMap: true,
                title: 'Service Areas'
            },
            children: [
                {
                    path: 'create',
                    name: 'Create service area',
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        isMap: true,
                        title: 'Create service area'
                    }
                }
            ]
        },
        {
            path: 'service-areas/dashboard/:date',
            name: 'Service Areas Dashboard',
            components: {
                default: ServiceAreasDashboardOverview
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'service-areas-dashboard',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'service-areas/:serviceAreaId/delivery-windows',
            name: 'Delivery Windows',
            components: {
                default: ServiceAreasDeliveryWindowPage
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'delivery-windows',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'service-areas/:serviceAreaId/blockout-days',
            name: 'Blockout Days',
            components: {
                default: ServiceAreasBlockoutDayPage
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'blockout-days',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'service-areas/:serviceAreaId/override-days',
            name: 'Override Days',
            components: {
                default: ServiceAreasOverrideDayPage
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'override-days',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly']
                }
            }
        },
        {
            path: 'driver-instructions',
            name: 'Driver Instructions',
            components: {
                default: DriverInstructions
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                isMap: true,
                title: 'Driver Instructions'
            }
        },
        {
            path: 'shipment-contents',
            name: 'Shipment Contents',
            components: {
                default: ShipmentContents
            },
            meta: {
                isSecure: true,
                hideFooter: true,
                hideTopbar: true,
                title: 'Shipment Contents'
            }
        },
        {
            path: 'rate-zones',
            name: 'Rate Zones',
            components: {
                default: RateZonesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                isMap: true
            }
        },
        {
            path: 'failed-delivery-configuration',
            name: 'Failed Delivery Configuration',
            components: {
                default: FailedDeliveryConfiguration
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'break-management',
            name: 'Break Management',
            components: {
                default: BreakManagementOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'break-management',
                    roles: ['Team Owner', 'Team Manager'],
                    isVisible: ['hasTeam', 'desktopOnly'],
                    featureRestrictions: [FEATURE_NAMES.BreakManagement]
                }
            }
        },
        {
            path: 'business-entities',
            name: 'Business Entities',
            components: {
                default: BusinessEntitiesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'business-entities/details/:businessEntityId',
            name: 'Business Entity Details',
            components: {
                default: BusinessEntityDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: 'tags',
            name: 'Tags',
            components: {
                default: Tags
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const ratesMenu = {
    path: '/rates',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Rates',
        security: {
            id: 'rates-engine',
            roles: ['Team Owner'],
            isVisible: ['hasTeam', 'desktopOnly'],
            chatbotScope: 'RatesEngine'
        }
    },
    redirect: '/rates/list',
    name: 'RatesDashboard',
    children: [
        {
            path: 'list',
            name: 'Rate',
            components: {
                default: RatesDashboard
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Rates'
            },
            children: [
                {
                    path: ':type',
                    name: 'Rate Dashboard Type',
                    components: {
                        default: RatesDashboard
                    },
                    meta: {
                        hideFooter: true,
                        hideTopbar: true,
                        title: 'Rate Dashboard'
                    }
                }
            ]
        }
    ]
};

const frequentAddressesMenu = {
    path: '/',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        security: {
            id: 'frequent-addresses',
            roles: ['Team Owner', 'Team Manager', 'Customer Admin'],
            isVisible: ['hasTeam', 'desktopOnly']
        }
    },
    redirect: '/frequent-addresses',
    name: 'Frequent Addresses',
    children: [
        {
            path: '/frequent-addresses',
            name: 'frequent-addresses',
            components: {
                default: FrequentAddressesOverview
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        },
        {
            path: '/frequent-addresses/:frequentAddressId',
            name: 'Frequent Address Details',
            components: {
                default: FrequentAddressDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true
            }
        }
    ]
};

const billingMenu = {
    path: '/billing',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Billing'
    },
    redirect: 'billing/profile',
    name: 'Billing',
    children: [
        {
            path: 'profile',
            name: 'Billing Profile',
            components: {
                default: BillingProfile
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'billing-profile',
                    requireLicense: false,
                    isVisible: ['desktopOnly']
                }
            }
        },
        {
            path: 'accounts',
            name: 'Billing Accounts',
            components: {
                default: BillingAccounts
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'billing-accounts',
                    isSupportOnly: true,
                    isVisible: ['desktopOnly']
                }
            }
        },
        {
            path: 'account-details',
            name: 'Billing Account Details',
            components: {
                default: BillingAccountDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'billing-account-details',
                    isSupportOnly: true,
                    isVisible: ['desktopOnly']
                }
            }
        },
        {
            path: 'ea-list',
            name: 'EA List',
            components: {
                default: EAList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                security: {
                    id: 'ea-list',
                    isSupportOnly: true,
                    isVisible: ['desktopOnly']
                }
            }
        }
    ]
};

const visionMenu = {
    path: '/vision',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Vision',
        security: {
            id: 'vision',
            roles: ['Team Owner', 'Team Manager', 'Office Staff'],
            featureRestrictions: [FEATURE_NAMES.PodAiVision],
            featureRestrictionType: 'hide'
        }
    },
    redirect: '/vision/images',
    name: 'Vision',
    children: [
        {
            path: 'images',
            name: 'POD Images',
            components: {
                default: VisionList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'POD Images'
            }
        }
    ]
};

const issueTracking = {
    path: '/issues',
    component: DashboardLayout,
    meta: {
        isSecure: true,
        title: 'Issues',
        security: {
            id: 'issues',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Team Member', 'Customer Admin'],
            isVisible: ['hasTeam'],
            featureRestrictions: [FEATURE_NAMES.IssueTracking]
        }
    },
    redirect: '/issues/list',
    name: 'Issues',
    children: [
        {
            path: 'list',
            name: 'Issues Overview',
            components: {
                default: IssueList
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Issues'
            }
        }
    ]
};

const tripRunsMenu = {
    path: '/runs',
    component: DashboardLayout,
    name: 'Runs',
    redirect: '/',
    meta: {
        isSecure: true,
        title: 'Runs',
        security: {
            id: 'trip-runs',
            isVisible: ['desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.TripRuns]
        }
    },
    children: [
        {
            path: 'details/:runId',
            name: 'Run Details',
            components: {
                default: TripRunsDetails
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Run Details'
            }
        }
    ]
};

// New Invoices menu with placeholder Team Member Invoice page
const teamMemberInvoicesAgGridMenu = {
    path: '/invoices',
    component: DashboardLayout,
    isVisible: ['hasTeam', 'desktopOnly'],
    meta: {
        isSecure: true,
        title: 'Invoices',
        security: {
            id: 'invoices-grid',
            roles: ['Team Owner', 'Team Manager', 'Office Staff', 'Team Member'],
            isVisible: ['hasTeam', 'desktopOnly'],
            featureRestrictions: [FEATURE_NAMES.Invoices]
        }
    },
    redirect: '/invoices/team-member-invoice',
    name: 'Invoices',
    children: [
        {
            path: 'team-member-invoice',
            name: 'Team Member Invoice',
            components: {
                default: TeamMemberInvoice
            },
            meta: {
                hideFooter: true,
                hideTopbar: true,
                title: 'Team Member Invoice'
            }
        }
    ]
};

const routes = [
    {
        path: '/',
        // eslint-disable-next-line no-nested-ternary
        redirect: !isMobile ? '/dashboard' : isMobileOnly ? '/dashboard' : '/stops',
        name: 'Home'
    },
    {
        path: '/w',
        component: Widgets
    },
    homeDashboard,
    mapsMenu,
    newMapMenu,
    jobsMenu,
    stopsMenu,
    tripsMenu,
    CustomerMenu,
    warehousesMenu,
    inventoryMenu,
    teamMemberInvoicesMenu,
    customerInvoicesMenu,
    shipmentsMenu,
    teamMembersMenu,
    userProfile,
    gpsReportsMenu,
    locationHistoryReport,
    distanceReport,
    stopReport,
    ignitionReport,
    safetyReport,
    safetySummaryReport,
    speedingReport,
    geofenceReport,
    geofenceTimesheetReport,
    batchStops,
    stopRatingReport,
    smsHistory,
    teamMemberDocumentReport,
    optimiseStops,
    authPages,
    invitePage,
    demo,
    paymentSuccess,
    pricing,
    assetTrackingMenu,
    onboarding,
    maintenanceMenu,
    frequentAddressesMenu,
    {
        path: '/',
        component: DashboardLayout,
        meta: {
            isSecure: true
        },
        children: [mapsMenu]
    },
    settingsMenu,
    marketPlace,
    ratesMenu,
    processChargesMenu,
    driverPaymentSummary,
    standaloneUserTeamMenu,
    driverPaymentSummary,
    ordersMenu,
    warehouseWebAppRoute,
    billingMenu,
    visionMenu,
    issueTracking,
    processChargesMenuAgGrid,
    tripRunsMenu,
    teamMemberInvoicesAgGridMenu
];

function updateRoutesSecurity() {
    function applySecurityToChild(child, security) {
        const newMeta = {
            security: { ...security }
        };

        if (!child.meta) {
            child.meta = { ...newMeta };
        } else if (!child.meta.security) {
            child.meta.security = security;
        }

        if (child.children?.length > 0) {
            child.children.forEach((child) => {
                applySecurityToChild(child, security);
            });
        }
    }

    routes.forEach((parent) => {
        const parentSecurity = parent.meta?.security;

        if (parentSecurity && parent.children?.length > 0) {
            parent.children.forEach((child) => {
                applySecurityToChild(child, parentSecurity);
            });
        }
    });
}

updateRoutesSecurity();

const router = new Router({
    mode: 'history',
    routes, // short for routes: routes
    scrollBehavior: (to, from, savedPosition) => {
        // scroll to top of page
        const layoutParent = document.querySelector('.layout-parent');

        if (layoutParent) {
            layoutParent.scrollIntoView();
        }

        return { x: 0, y: 0 };
    },
    linkActiveClass: 'nav-item active' // active class for non-exact links like /trips/list/:date
});

router.beforeEach(async (to, from, next) => {
    router.app.$modal.hide();
    if (to.matched.some((record) => record.meta.isSecure)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.

        await window.auth.isLoggedIn().then(async (isLoggedIn) => {
            if (isLoggedIn) {
                let user = store.getters['user/user'];

                if (user == null) {
                    const api = '/api/users/me/profile';
                    const { data } = await handleRequests(api);
                    user = data;
                }

                if (!user.license?.status || user.license.status === 'Disabled') {
                    // New billing system customers: redirect to Customer Portal
                    if (user.billingVersion === NEW_BILLING_VERSION) {
                        // eslint-disable-next-line import/no-dynamic-require, global-require
                        const { config } = require(`../config/config.${process.env.NODE_ENV}`);
                        if (config.billing_customer_portal_url) {
                            window.location.href = config.billing_customer_portal_url;
                            return;
                        }
                    }

                    // Legacy billing: allow them to login and manage their license
                    if (to.meta.security?.id === 'billing-profile') {
                        next();
                    } else {
                        next({ path: '/billing/profile' });
                    }

                    return;
                }

                if (
                    // eslint-disable-next-line array-callback-return
                    to.matched.some((record) => {
                        if (record.meta?.security?.id && record.meta?.security?.id === 'team-settings-menu') {
                            if (!user.hasTeam) {
                                next();
                                return;
                            }
                        }

                        if (
                            record.meta?.security?.featureRestrictionType &&
                            record.meta?.security?.featureRestrictionType === 'hide'
                        ) {
                            next();
                            return;
                        }

                        if (!canRouteAndShow(record, user)) {
                            if (
                                user.role === 'Customer' ||
                                user.role === 'Customer Admin' ||
                                !user.hasTeam ||
                                user.role === 'Team Member' ||
                                user.role === 'Support Staff'
                            ) {
                                next({ path: '/stops' });
                                return;
                            }

                            next({ path: '/dashboard' });

                            return;
                        }

                        next();
                    })
                )
                    ;
            } else if (to.matched.some((record) => record.meta.shouldLoginAutomatically)) {
                localStorage.setItem('invitationUrl', to.fullPath);
                window.auth.login();
            } else if (from.fullPath === to.fullPath) {
                // For some reason when we call in some pages the 'this.$router.replace' method, if we logout the rooter after it logs out it calls the beforeEach hook with the same from-to fullpath in the parameters.
                // Not sure of why but we can trap it and ensure that if the user is not loged in we don't navigate there.
                next(false);
            } else {
                window.auth.login();
            }
        });
    } else {
        next();
    }
});

export default router;
